import { render, staticRenderFns } from "./citizen-view.vue?vue&type=template&id=68583eb9&"
import script from "./citizen-view.vue?vue&type=script&lang=js&"
export * from "./citizen-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports